import { render, staticRenderFns } from "./MontageStromIcon.vue?vue&type=template&id=5e0509ac&scoped=true"
import script from "./MontageStromIcon.vue?vue&type=script&lang=js"
export * from "./MontageStromIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0509ac",
  null
  
)

export default component.exports